/**
 * Role (brief kroku 8, 04 §2). Identifikatory vzdy anglicky.
 * Staff role ziju v organizacni strukture tenantu; portalove role patri
 * stranam (prodavajici/kupujici/najemce/majitel/developer) pres magic link
 * - maji dosah jen na zdroje, s nimiz maji prime vztahy (reach 'own').
 */
export const STAFF_ROLES = [
    'owner',
    'admin',
    'broker',
    'assistant',
    'finance',
    'legal',
    'pm_manager',
    'viewer',
];
/**
 * Krok QAFIX3 bod 5 (nalez QAFIX1 ZBYVA) — VYCHOZI STAFF ROLE.
 *
 * Better Auth zaklada clenstvi organizace s vlastni vychozi roli `member`,
 * kterou REOS NEZNA: `ROLE_ACTIONS['member']` neexistuje, takze takovy ucet
 * dostane 403 na vsechno (dva testovaci ucty KR1, 20. 10. 2026 prepsane
 * rucne na `broker`). Kazda cesta zapisu clenstvi proto dopise TUHLE roli,
 * kdyz volajici zadnou neurci - jedno misto, ne osm.
 */
export const DEFAULT_STAFF_ROLE = 'broker';
export const PORTAL_ROLES = ['seller', 'buyer', 'tenant', 'owner_portal', 'developer'];
export const ALL_ROLES = [...STAFF_ROLES, ...PORTAL_ROLES];
export function isStaffRole(role) {
    return STAFF_ROLES.includes(role);
}
export function isPortalRole(role) {
    return PORTAL_ROLES.includes(role);
}
/**
 * Maximalni rozsah role v ramci tenantu (04 §2: owner tenant, manager office,
 * broker team + ucastnictvi, portal jen vlastni zdroje).
 *
 * Rozsah se NAROVNAVA vztahem k konkretnimu zdroji (ucastnik case / prirazeny
 * uzivatel / vlastnik) - viz engine.ts. Zuzit ji nelze.
 */
export const ROLE_REACH = {
    owner: 'tenant',
    admin: 'tenant',
    // Finance a legal pracuji s podklady celeho tenantu (ucto/pravni oddeleni).
    finance: 'tenant',
    legal: 'tenant',
    // Broker/assistant vidi svuj tym + cokoli, kde jsou ucastnikem case.
    broker: 'team',
    assistant: 'team',
    // Vedouci spravy nemovitosti vidi celou kancelar.
    pm_manager: 'office',
    viewer: 'office',
    // Portalove role: jen zdroje s primym vztahem (ucastnik/vlastnik/prirazeno).
    seller: 'own',
    buyer: 'own',
    tenant: 'own',
    owner_portal: 'own',
    developer: 'own',
};
/**
 * Role s pristupem k sensitive_identity (doklady, rodna cisla, PEP screening;
 * 04 §2 ABAC + threat model asset `sensitive_identity`).
 * Broker k dokladum strany potrebuje explicitni grant - mechanismus doplni
 * identity kontext (nalez v reportu kroku 8), policy ho uz ted hlida.
 */
export const SENSITIVE_READ_ROLES = ['owner', 'admin', 'legal'];
/** Role, kterou nese service principal do auditu a app.role GUC. */
export const SERVICE_ROLE = 'service';
//# sourceMappingURL=roles.js.map